import { z } from "zod"

export const BackofficeShopifyMetafieldsAuditResponseDataSchema = z.object({
  success: z.boolean(),
})
